<template>
    <div class="modalBackground">
        <div class="ModalForm">
            <div class="header">
                <h1 class="Title">Manage User</h1>
                <div class="Options">
                    <button v-on:click.stop="save()">Save</button>
                    <button v-on:click.stop="close()">Close</button>
                </div>
            </div>
            <div class="modalBody" v-if="User === null || Roles == null">
                <p><loading-indicator /> Loading User/Roles...</p>
            </div>
            <div class="modalBody" v-if="Saving">
                <p><loading-indicator /> Saving User...</p>
            </div>
            <div class="modalBody" v-if="!Saving && User !== null">

                <h3>Note's</h3>
                <div v-if="User.userNotes !== null && User.userNotes.length > 0">
                    <table>
                        <thead>
                            <tr>
                                <th>Note</th>
                                <th>Author</th>
                                <th>Date Added</th>
                            </tr>
                        </thead>
                        <tbody v-if="User.userNotes !== null">
                            <tr v-for="(userNote,index) in User.userNotes" :key="index">
                                <td>{{ userNote.text }} </td>
                                <td>{{ userNote.author }}</td>
                                <td>{{ userNote.notesDate }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <p v-else>No Notes</p>
                <button @click="addNote()">Add new note</button> <button @click="refreshNotes()">Refresh Notes</button>
                <h2>Registration Details</h2>

                <label>Username: <span>{{User.userName}}</span></label><br />
                <label>Email: <span><a :href="'mailto:' + User.email">{{User.email}}</a></span></label><br />
                <label>Email Confirmed: <span v-bind:class="User.emailConfirmed ? 'Positive' : 'Negative'">{{User.emailConfirmed? "Yes" : "No"}}</span></label><span v-if="!User.emailConfirmed"> (<a target="_blank" :href="'https://auth.ftrc.co/AdminResendConfirmationEmail/' + userId">Resend Confirmation Email.</a>)<br /></span>
                <label>First Name: <input type="text" v-model="User.firstName" /></label><br />
                <label>Last Name: <input type="text" v-model="User.lastName" /></label><br />
                <label>Phone Name: <span><a :href="'callto:'+User.phoneNumber"> {{User.phoneNumber}}</a></span></label><br />
                <label>
                    Address:<br />
                    <span>{{User.businessAddressLine1}}</span><br />
                    <span>{{User.businessAddressLine2}}</span><br />
                    <span>{{User.businessAddressPostCode}}</span><br />
                    <span>{{User.businessAddressCountry}}</span><br />
                </label>
                <label>Industry: <span>{{User.industry}}</span></label><br />
                <label>Organisation Name: <input type="text" v-model="User.organisationName" /></label><br />
                <label>Organisation Type: <span>{{User.organisationType}}</span></label><br />
                <label v-if="User.unipassFirmID !== '' && User.unipassFirmID !== null">Unipass Firm ID: <span>{{User.unipassFirmID}}</span></label>
                <label>Job Title: <span>{{User.jobTitle}}</span></label><br />
                <label>Network/Support Group: <span>{{User.supportNetwork}}</span></label><br />
                <label>Organisation FCA No: <span>{{ User.organisationFcano === null ? "N/A" : User.organisationFcano }}</span></label><br />
                <label>Are you the primary individual in your organisation responsible for selecting technology used in your business?: <span>{{User.responsibleForSelectingTechnology}}</span></label><br />
                <label>Requested Access to Protection Guru: <span>{{User.requestedAccessToPgpro? "Yes" : "No"}}</span></label><br />
                <label>Requested Protection Guru Email Preference: <span>{{User.signUpForPgemailsPreference}}</span></label><br />
                <label>Current Protection Guru Email Preference: <span>{{User.currentPGMailingListStatus}}</span></label><br />
                <label>Requested Access to Benefits Guru: <span>{{User.requestedAccessToBgpro? "Yes" : "No"}}</span></label><br />
                <label>Requested Benefits Guru Email Preference: <span>{{User.signUpForBgemailsPreference}}</span></label><br />
                <label>Current Benefits Guru Email Preference: <span>{{User.currentBGMailingListStatus}}</span></label><br />
                <label>Requested Access to Adviser Software Insights: <span>{{User.requestedAccessToAsi? "Yes" : "No"}}</span></label><br />
                <label>Requested Adviser Software Insights Email Preference: <span>{{User.signUpForAsiemailsPreference}}</span></label><br />
                <label>Current ASI Email Preference: <span>{{User.currentASIMailingListStatus}}</span></label><br />
                <label>How you heard about us?: <span>{{User.heardResponse}}</span></label><br />
                <label>Which platform?: <span>{{User.heardResponseWithOthers !== "" && User.heardResponseWithOthers !== null  && User.heardResponseWithOthers.includes("|") ? User.heardResponseWithOthers.replace('|', ' - ') : User.heardResponseWithOthers }}</span></label><br />

                <h2>PGP Subscription details</h2>
                <label>Subscription Type: <span>{{User.subscriptionDetails.type}}</span></label><br />
                <label>Number of unused credits: <span>{{User.subscriptionDetails.credits}}</span></label><br />
                <label>PGP Subscription status: <span>{{User.subscriptionDetails.status}}</span></label><br />
                <label>Subscription started on: <span>{{User.subscriptionDetails.createdAt}}</span></label><br />
                <label v-if="User.subscriptionDetails.renewalDate != 'N/A'">Subscription renewal on: <span>{{User.subscriptionDetails.renewalDate}}</span></label><br v-if="User.subscriptionDetails.renewalDate != 'N/A'" />

                <h2>Assigned Companies/Roles</h2>
                <!-- Add Company/Role Selection -->
                <span v-for="(company, companyIndex) in Companies" :key="companyIndex">
                    <label v-if="company.roles.length === 1"><input type="checkbox" :value="company.roles[0].id" v-model="User.assignedRoles" /> {{company.roles[0].name}}</label>
                    <strong v-if="company.roles.length > 1" style="cursor:pointer;padding-left:3px;" @click="expandCollapseCompany(company.name)">{{company.isExpanded ? "▼" : "▶"}} {{company.name}}</strong>
                    <ul v-if="company.roles.length > 1 && company.isExpanded" style="margin:0">
                        <li v-for="(role, index) in company.roles" :key="role.id" style="list-style:none;"><label><input type="checkbox" :value="role.id" v-model="User.assignedRoles" /><i style="font-weight:bold;" v-if="index ==0">All</i><span style="font-weight:bold;" v-else>{{role.name.split('~')[1]}}</span></label></li>
                    </ul>
                </span>
                <h2>User Login Details</h2>
                <label>Registration Date: <span>{{displayDate(User.dateRegistered)}}</span></label>
                <label>Last Login: <span>{{displayDate(User.lastLogin)}}</span></label>
                <label v-if="(User.lockoutEnabled === true) && User.lockoutEnd !== null">User locked out until: <span></span></label>
                <label>Incorrect Login Count: <span>{{User.accessFailedCount}}</span></label>
                <label>
                    Status: <select v-model.number="User.userStatus">
                        <option value="0">Awaiting Approval</option>
                        <option v-if="User.emailConfirmed || User.userStatus === 1" value="1">Approved</option>
                        <option value="2">Rejected</option>
                        <option v-if="User.isBulkUser" value="3">Bulk User</option>
                        <option v-if="(!User.emailConfirmed) || User.userStatus === 4" value="4">Pre-Approved</option>
                    </select>
                </label>
                <label v-if="(User.userStatus === 1 || User.userStatus === 4) && User.approvedBy !== null">Last approved by: <span>{{User.approvedBy}}</span></label>
                <label v-if="User.userStatus === 1"><input type=checkbox v-model="SendConfirmationEmail" /> Send Confirmation Email</label>
                <label>Rejection Reason: <textarea v-model="User.rejectionReason"></textarea></label>
                <h2>User Access</h2>
                <label><input type="checkbox" v-model="User.isAdmin" /> Admin User</label>
                <h3>Protection Guru Pro</h3>
                <label>Access to Protection Guru Pro: <nullable-user-select v-model="User.hasAccessToPgpro" /></label>
                <label title="leave blank for unlimited comparisons per month" v-if="User.hasAccessToPgpro === true">Allowed Comparisons per Month: <nullable-integer-input v-model="User.pgproComparisonsPerMonth" /> <i>(leave blank for unlimited comparisons per month)</i></label>
                <label title="leave blank for unlimited features per comparisons" v-if="User.hasAccessToPgpro === true">Allowed Features per Comparison: <nullable-integer-input v-model="User.pgproFeatureLimit" /> <i>(leave blank for unlimited features per comparison)</i></label>
                <label title="leave blank for unlimited providers per comparisons" v-if="User.hasAccessToPgpro === true">Allowed Providers per Comparison: <nullable-integer-input v-model="User.pgproProviderLimit" /> <i>(leave blank for unlimited providers per comparison)</i></label>
                <label v-if="User.hasAccessToPgpro === true">Access to Protection Guru Pro Ad Free: <nullable-user-select v-model="User.pgproAdFreeAccess" /></label>
                <label v-if="User.hasAccessToPgpro === true">Access to Protection Guru Pro Pricing: <nullable-user-select v-model="User.pgproAccessToPricing" /></label>
                <label v-if="User.hasAccessToPgpro === true">Access to Protection Guru Pro Value: <nullable-user-select v-model="User.pgproAccessToValue" /></label>
                <label v-if="User.hasAccessToPgpro === true">Access to Copy Protection Guru Pro Graphs: <nullable-user-select v-model="User.pgproAccessToCopyGraphs" /></label>
                <label v-if="User.hasAccessToPgpro === true">Access to Protection Guru Pro DataTables (outside of reports): <nullable-user-select v-model="User.pgproDataTableAccess" /></label>
                <label v-if="User.hasAccessToPgpro === true">Access to Protection Guru Pro Legacy Products: <nullable-user-select v-model="User.pgproLegacyProductAccess" /></label>
                <label v-if="User.hasAccessToPgpro === true">Access to Protection Guru Pro Reports: <nullable-user-select v-model="User.pgproReportAccess" /></label>
                <label v-if="User.hasAccessToPgpro === true && User.pgproReportAccess == true">Access to Protection Guru Pro DataTables in Report: <nullable-user-select v-model="User.pgproDataTableAccessInReport" /></label>
                <label>Access to Protection Guru Pro Datatables ONLY: <nullable-user-data-table-select v-model="User.hasAccessToPGProDataTableOnly" /></label>
                <h3>Benefits Guru Pro</h3>
                <label>Access to Benefits Guru Pro: <nullable-user-select v-model="User.hasAccessToBgpro" /></label>
                <label title="leave blank for unlimited comparisons per month" v-if="User.hasAccessToBgpro === true">Allowed Comparisons per Month: <nullable-integer-input v-model="User.bgproComparisonsPerMonth" /> <i>(leave blank for unlimited comparisons per month)</i></label>
                <label title="leave blank for unlimited features per comparisons" v-if="User.hasAccessToBgpro === true">Allowed Features per Comparison: <nullable-integer-input v-model="User.bgproFeatureLimit" /> <i>(leave blank for unlimited features per comparison)</i></label>
                <label title="leave blank for unlimited providers per comparisons" v-if="User.hasAccessToBgpro === true">Allowed Providers per Comparison: <nullable-integer-input v-model="User.bgproProviderLimit" /> <i>(leave blank for unlimited providers per comparison)</i></label>
                <label v-if="User.hasAccessToBgpro === true">Access to Benefits Guru Pro Ad Free: <nullable-user-select v-model="User.bgproAdFreeAccess" /></label>
                <label v-if="User.hasAccessToBgpro === true">Access to Copy Benefits Guru Pro Graphs: <nullable-user-select v-model="User.bgproAccessToCopyGraphs" /></label>
                <label v-if="User.hasAccessToBgpro === true">Access to Benefits Guru Pro DataTables (outside of reports): <nullable-user-select v-model="User.bgproDataTableAccess" /></label>
                <label v-if="User.hasAccessToBgpro === true">Access to Benefits Guru Pro Reports: <nullable-user-select v-model="User.bgproReportAccess" /></label>
                <label v-if="User.hasAccessToBgpro === true && User.bgproReportAccess == true">Access to Benefits Guru Pro DataTables in Report: <nullable-user-select v-model="User.bgproDataTableAccessInReport" /></label>

                <h3>Wordpress Websites</h3>
                <label>Access to Adviser Software Insights Wordpress Site: <nullable-user-select v-model="User.asiwordPressWebsiteAccess" /></label>
                <label>Access to Benefits Guru Wordpress Site: <nullable-user-select v-model="User.bgwordPressWebsiteAccess" /></label>
                <label>Access to Protection Guru Wordpress Site: <nullable-user-select v-model="User.pgwordPressWebsiteAccess" /></label>

                <br />


            </div>
        </div>
    </div>
</template>

<script>
    import NullableUserSelect from './NullableUserSelect.vue';
    import NullableUserDataTableSelect from './NullableUserDataTableSelect.vue';
    import LoadingIndicator from './LoadingIndicator.vue';
    import NullableIntegerInput from './NullableIntegerInput.vue';
    import $ from 'jquery';

    export default {
        name: 'User',
        components: {
            LoadingIndicator,
            NullableUserSelect,
            NullableIntegerInput,
            NullableUserDataTableSelect
        },
        props: ["userId"],
        created: function () {
            var myComponent = this;
            $.ajax({
                type: 'GET',
                url: 'LocalUsers/' + this.userId,
                dataType: 'json',
                success: function (data) {
                    myComponent.User = data;
                }

            });
            $.ajax({
                type: 'GET',
                url: 'Roles/',
                dataType: 'json',
                success: function (data) {
                    myComponent.Roles = data;
                }

            });
        },
        data: function () {
            return {
                ExpandedCompanies: [],
                User: null,
                Roles: null,
                SendConfirmationEmail: false,
                Saving: false,
                isSyncingPGProAccess: false
            }
        },
        methods: {
            expandCollapseCompany: function (company) {
                if (this.ExpandedCompanies.indexOf(company) === -1)
                    this.ExpandedCompanies.push(company)
                else
                    this.ExpandedCompanies.splice(this.ExpandedCompanies.indexOf(company), 1);
            },
            displayDate: function (d) {
                if (d === null)
                    return "-";
                return d.substr(8, 2) + "/" + d.substr(5, 2) + "/" + d.substr(0, 4);
            },
            close: function () {
                this.$emit('update:userId', null);
            },
            getStatusText: function (status) {
                if (status === 0)
                    return "Awaiting Approval";
                if (status === 1)
                    return "Approved";
                if (status === 2)
                    return "Rejected";
            },
            "addNote": function () {
                var thisControl = this;
                var vNote = prompt("Enter Note:");
                if (vNote != null && vNote != undefined && vNote != "") {
                    $.ajax({
                        type: 'PUT',
                        url: "/Settings/AddNote" + "/" + thisControl.userId,
                        data: JSON.stringify(vNote),
                        contentType: 'application/json',
                        dataType: 'json',
                        error: function (xhr) {
                            alert("Error adding Note:" + xhr.responseText);
                        },
                        success: function () {
                            thisControl.refreshNotes();
                        }
                    });
                }
            },
            "refreshNotes": function () {
                var thisControl = this;

                $.ajax({
                    type: 'GET',
                    url: "/Settings/ViewNotes" + "/" + thisControl.userId,
                    dataType: 'json',
                    error: function (xhr) {
                        alert("Error refreshing Notes:" + xhr.responseText);
                    },
                    success: function (data) {
                        thisControl.User.userNotes = data;
                    }
                });

            },

            save: function () {
                var thisControl = this;
                this.Saving = true;
                $.ajax({
                    type: 'POST',
                    url: "/LocalUsers/" + this.SendConfirmationEmail + "?sendEmail=" + this.SendConfirmationEmail,
                    contentType: 'application/json',
                    data: JSON.stringify(this.User),
                    success: function () {
                        thisControl.Saving = false;
                        thisControl.$emit('update:userId', null);
                    },
                    error: function (xhr) {
                        thisControl.Saving = false;
                        alert("Error saving:" + xhr.responseText);
                    }
                });
            }
        },
        watch: {
            "User.userStatus": function (newValue, oldValue) {
                if (newValue === 1 && (oldValue === 0 || oldValue === 2))
                    this.SendConfirmationEmail = true;
            },
            "User.hasAccessToPGProDataTableOnly": function (newValue) {
                if (this.isSyncingPGProAccess) return;
                this.isSyncingPGProAccess = true;
                if (newValue === true) {
                    this.User.hasAccessToPgpro = false; 
                } else if (newValue === false) {
                    this.User.hasAccessToPgpro = true; 
                }
                this.isSyncingPGProAccess = false;
            },
            "User.hasAccessToPgpro": function (newValue) {
                if (this.isSyncingPGProAccess) return;
                this.isSyncingPGProAccess = true;
                if (newValue === true) {
                    this.User.hasAccessToPGProDataTableOnly = false; 
                } else if (newValue === false) {
                    this.User.hasAccessToPGProDataTableOnly = true; 
                }
                this.isSyncingPGProAccess = false;
            }
        },


        computed: {
            Companies: function () {
                if (this.Roles == null)
                    return null;
                var result = [];
                var company = null;
                for (var r = 0; r < this.Roles.length; r++) {
                    var role = this.Roles[r];
                    if (role.name.indexOf("~") == -1) {
                        company = {
                            roles: [role],
                            name: role.name,
                            isExpanded: this.ExpandedCompanies.indexOf(role.name) === -1 ? false : true
                        };
                        result.push(company);
                    }
                    else {
                        company.roles.push(role);
                    }
                }
                return result;
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->